// extracted by mini-css-extract-plugin
export default {"students":"ProfilesStats_students__0455o","active":"ProfilesStats_active__nXt29","inactive":"ProfilesStats_inactive__wD12D"};